import React, { Children } from 'react'
import { withStyles } from '@material-ui/core/styles'

import Scaffolding from '../scaffolding/dynamic'
import Header from '../scaffolding/widgets/header'
import Topper from '../scaffolding/widgets/topper'
import Leader from '../scaffolding/widgets/leader'
import Linker from '../scaffolding/widgets/linker'
import Contenter from '../scaffolding/widgets/contenter'
import Quoter from '../scaffolding/widgets/quoter'
import Imager from '../scaffolding/widgets/imager'
import Contacter from '../scaffolding/widgets/contacter'
import Footer from '../footer'
import styles from './styles'

class ShotContent extends Scaffolding {
  render() {
    const { data, metadata, policies, classes } = this.props
    const { mapper, topper, contents } = data

    this.reset()

    return (
      <div>
        <Header
          image={topper.background_image}
          video={topper.background_video}
          gradient={topper.gradient}
        />

        <div className={classes.mainFloat}>
          <Topper topper={topper} />
          <Leader topper={topper} />
          <Layout
            mapper={mapper}
            contents={contents}
            count={this.count}
            inc={this.inc}
          />
        </div>
        <Footer policies={policies} />
      </div>
    )
  }
}

const Layout = props => {
  const { mapper, contents, count, inc } = props
  return mapper.map((type, key) => {
    switch (type) {
      case 'image':
        return (
          <Imager contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      case 'content':
        return (
          <Contenter contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      case 'quote':
        return (
          <Quoter contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      case 'contact':
        return (
          <Contacter
            contents={contents}
            type={type}
            inc={inc}
            count={count}
            selected={[]}
            key={key}
          />
        )
        break
      case 'content':
        return (
          <Contenter contents={contents} type={type} inc={inc} count={count} key={key}/>
        )
        break
      case 'content_link':
        return (
          <Linker
            contents={contents}
            type={type}
            inc={inc}
            count={count}
            key={key}
          />
        )
        break
      default:
        break
    }
  })
}

export default withStyles(styles)(ShotContent)



// WEBPACK FOOTER //
// ./src/components/shot/index.js